import { Component } from '@builder.io/sdk';

export const config: Component = {
    name: 'Hubspot Form Section',
    description:
        'Two-column layout: left side with title and optional testimonial, right side with HubSpot form and customizable background.',
    inputs: [
        {
            name: 'title',
            type: 'string',
            friendlyName: 'Title',
            defaultValue: 'Learn how Storyblocks can work for your company',
        },
        {
            name: 'formId',
            type: 'string',
            friendlyName: 'HubSpot Form ID',
            required: true,
            helperText: 'Paste the HubSpot form ID',
            defaultValue: 'c3514b58-be2d-415e-9fd0-51866219148c',
        },
        {
            name: 'backgroundImage',
            type: 'file',
            friendlyName: 'Background Image (Right Column)',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            helperText: 'Background image for the right column (behind the form)',
        },
        {
            name: 'backgroundColor',
            type: 'color',
            friendlyName: 'Background Color',
            defaultValue: 'var(--color-blue-900)',
        },
        {
            name: 'showTestimonial',
            type: 'boolean',
            friendlyName: 'Show Testimonial',
            defaultValue: true,
            helperText: 'Toggle to show or hide the testimonial below the title',
        },
        {
            name: 'testimonialQuote',
            type: 'richText',
            friendlyName: 'Testimonial Text',
            required: false,
            defaultValue:
                'Whether it was necessary but hard-to-capture-myself stock for a client video, or some beautiful aerial for a YouTube video, I have used Storyblocks to create <em>compelling, emotional, and impactful content</em>.',
            helperText: 'Main testimonial quote (supports rich text formatting)',
        },
        {
            name: 'testimonialName',
            type: 'string',
            friendlyName: 'Author Name',
            required: false,
            defaultValue: 'Cody Wanner',
            helperText: 'Name of the testimonial author',
        },
        {
            name: 'testimonialTitle',
            type: 'string',
            friendlyName: 'Author Title / Company',
            required: false,
            defaultValue: 'YouTuber & Content Creator',
            helperText: 'Optional author title or company',
        },
        {
            name: 'testimonialBackgroundColor',
            type: 'color',
            friendlyName: 'Testimonial Background Color',
            required: false,
            defaultValue: 'var(--color-olive-100)',
            helperText: 'Background color for the testimonial card',
        },
        {
            name: 'testimonialAccentColor',
            type: 'color',
            friendlyName: 'Testimonial Accent Color',
            required: false,
            defaultValue: 'var(--color-olive-700)',
            helperText: 'Color used for the large opening quotes icon',
        },
    ],
};
